import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'
import {getVersion} from '../../utils/version'
import type {CorePluginFunction} from '../../types'

export const pack: CorePluginFunction = (componentExport: ComponentWithResolvedDataItems) => {
    componentExport.version = getVersion()
}
